import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "admin-header"
}
const _hoisted_2 = {
  key: 0,
  class: "buttons"
}
const _hoisted_3 = {
  key: 0,
  class: "legend",
  id: "legend-map"
}
const _hoisted_4 = {
  key: 0,
  class: "map-info-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["map-wr", { isBuilderView: $setup.props.builderView }])
  }, [
    ($setup.props.role === $setup.UserRoles.SUPER_ADMIN)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "title-main" }, "Map", -1)),
          ($setup.map !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (!$setup.map)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "button default primary add-btn-primary",
                      onClick: $setup.toCreateMap
                    }, "Add Map"))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("button", {
                        class: "button default outlined",
                        onClick: $setup.toEditMap
                      }, "Edit Map"),
                      _createElementVNode("button", {
                        class: "button default outlined warning",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showConfirmDeleteModal = true))
                      }, "Delete Map")
                    ], 64))
              ]))
            : _createCommentVNode("", true),
          _createVNode($setup["ConfirmDeleteModal"], {
            isOpen: $setup.showConfirmDeleteModal,
            deleteItem: 'estate map',
            onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.showConfirmDeleteModal = false)),
            onConfirm: $setup.deleteMap
          }, null, 8, ["isOpen"])
        ]))
      : _createCommentVNode("", true),
    (!$setup.isDesktop && $setup.props.role === $setup.UserRoles.CUSTOMER && !$setup.props.isEmbedded)
      ? (_openBlock(), _createBlock($setup["StageNavMobile"], {
          key: 1,
          estateId: $setup.estateId,
          mapPage: $setup.props.mapPage,
          isEmbedded: $setup.props.isEmbedded,
          onOnStage: _cache[2] || (_cache[2] = ($event: any) => ($setup.onStage($event))),
          onChangeView: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('changeView')))
        }, null, 8, ["estateId", "mapPage", "isEmbedded"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["svg-wrapper", { isEmbeddedDesktop: $setup.isEmbeddedDesktop, isBuilderView: $setup.props.builderView }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["svg-container-map", { 'svg-map-embedded': $setup.isEmbeddedDesktop, isBuilderView: $setup.props.builderView }])
      }, [
        ($setup.isEmbeddedDesktop)
          ? (_openBlock(), _createBlock($setup["MapSidePanel"], {
              key: 0,
              estateId: $setup.estateId,
              hoverStageId: $setup.hoverStageId,
              lotsByHouseDesigns: $setup.props.lotsByHouseDesigns,
              builderView: $setup.props.builderView,
              hideOptions: $setup.props.hideMapSidePanelOptions,
              onOnStageHover: $setup.onSidePanelStageHover,
              onOnStageClick: $setup.onSidePanelStageClick,
              onOnRegister: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('onRegister'))),
              onOnMessage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('onMessage')))
            }, null, 8, ["estateId", "hoverStageId", "lotsByHouseDesigns", "builderView", "hideOptions"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["map-elements-container", { 'map-max-width': $setup.isEmbeddedDesktop }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["map-elements-wr", { isBuilderView: $setup.props.builderView }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["zoom-container", [{ 'zoom-active': $props.zoom !== 1 && $setup.isDesktop }, { 'zoom-desktop-embedded': $setup.isEmbeddedDesktop }, { 'zoom-hidden': $setup.props.builderView }]])
            }, [
              _createElementVNode("button", {
                class: "button zoom-btn",
                onClick: $setup.zoomIn
              }, "+"),
              _createElementVNode("button", {
                class: "button zoom-btn",
                onClick: $setup.zoomOut
              }, "-")
            ], 2),
            ($setup.props.role !== $setup.UserRoles.SUPER_ADMIN && $setup.isDesktop)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["map-info-block", { 'map-info-embedded': $setup.isEmbeddedDesktop }])
                }, [
                  (!$setup.isEmbeddedDesktop)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("div", { class: "status gray" }, "Not Released", -1),
                        _createElementVNode("div", { class: "status success" }, "Now Selling", -1),
                        _createElementVNode("div", { class: "status warning" }, "Sold Out", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["scroll-wrapper", [{ 'svg-container grab': $setup.props.zoom !== 1 }, { 'map-container-side': $setup.isEmbeddedDesktop }]]),
              ref: "svgContainerMap",
              onMousedown: $setup.startDrag,
              onMousemove: $setup.handleDrag,
              onMouseup: $setup.stopDrag
            }, [
              _createVNode($setup["EstateSvgMap"], {
                map: $setup.map,
                stages: $setup.stages,
                getTooltipText: $setup.getTooltipText,
                getItemPathClasses: $setup.getItemPathClasses,
                zoom: $setup.props.zoom,
                onOnStageHover: $setup.onStageHover,
                onOnStageLeave: $setup.onStageLeave,
                onOnStageClick: $setup.onStage
              }, null, 8, ["map", "stages", "zoom"])
            ], 34)
          ], 2)
        ], 2),
        ($setup.isEmbeddedDesktop && !$setup.props.builderView)
          ? (_openBlock(), _createBlock($setup["MapSideLegend"], {
              key: 1,
              isEstateMap: true
            }))
          : _createCommentVNode("", true)
      ], 2),
      ($setup.props.role !== $setup.UserRoles.SUPER_ADMIN && !$setup.isEmbeddedDesktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("div", {
              class: "legend",
              id: "legend-map"
            }, [
              _createElementVNode("div", { class: "status gray" }, "Not Released"),
              _createElementVNode("div", { class: "status success" }, "Now Selling"),
              _createElementVNode("div", { class: "status warning" }, "Sold Out")
            ], -1)
          ]))]))
        : _createCommentVNode("", true),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "map-info-iframe" }, null, -1))
    ], 2)
  ], 2))
}